<script>
    import {name} from '../stores';
    const env = MODE || "dev";
</script>

<div class="space-container"><span class='space'>{env === "dev" ? $name + " (dev)" : $name}</span></div>